import Vue from "vue";
import Vuex from "vuex";

// import * as auth from "./modules/auth.js";
import * as plan from "./modules/plan.js";
// import * as workoutPlan from "./modules/workoutPlan.js";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    // auth,
    plan,
    // workoutPlan
  },
  actions: {
    resetState({ commit }) {
      // commit("auth/reset")
      commit("plan/RESET");
    }
  }
});

// export default new Vuex.Store({
//   state: {
//     "test": "yep"
//   },
//   mutations: {
//   },
//   actions: {
//   },
//   modules: {
//   }
// })
